module.exports = "<md-content id=\"calculations\" md-padding>\n    <calculation-grid calculations=\"calculations\"></calculation-grid>\n</md-content>";